<template>
  <v-row no-gutters>
    <v-col
      v-for="(item, index) in services"
      v-if="can(item.gate, 'show') || can(item.gate, 'active')"
      :key="index"
      v-is-show="item.gate"
      class="py-5 px-4 py-sm-6 py-md-8 zoom"
      cols="12"
      lg="3"
      md="4"
      sm="6"
      :class="
        $i18n.locale !== 'fa' && !activeNonPersianServices.includes(item.gate)
          ? 'opacity-60'
          : ''
      "
    >
      <v-card
        :href="redirectTo(item.name, item.gate)"
        class="transparent d-flex"
        flat
        height="100%"
        width="100%"
      >
        <div class="main-img-wrapper">
          <v-badge
            :color="
              item.badge
                ? 'orange'
                : item.isFree
                ? preRegister.includes(item.name)
                  ? 'orange'
                  : 'bg-success'
                : item.comingSoon
                ? 'third'
                : item.isTest
                ? 'bg-warning'
                : ''
            "
            :content="
              item.badge
                ? item.badge
                : item.isFree
                ? preRegister.includes(item.name)
                  ? $t('badges.preRegister')
                  : $t('badges.free')
                : item.comingSoon
                ? $t('badges.comingSoon')
                : item.isTest
                ? $t('badges.testVersion')
                : ''
            "
            :value="item.isFree || item.comingSoon || item.isTest || item.badge"
            bottom
            left
            offset-y="10"
          >
            <img :src="item.icon" alt="" height="58" width="58" />
          </v-badge>
          <!--                        <div style="width: 72px;height: 72px;background-color: gray;border-radius: 50%"></div>-->
        </div>

        <div :class="checkOverflow(index)" class="bottom-sec">
          <div class="bottom-text" v-text="item.description" />
        </div>

        <div :id="`main.text.${index}`" class="main-sec">
          <div
            :id="`text.wrapper.${index}`"
            class="main-text-wrapper"
            v-text="item.title"
          />
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import BtnUPAndDown from "@/view/layout/home/BtnUPAndDown";
import i18n from "../../../core/plugins/TitleRibbon/plugins/EasyModal/i18n";

const { can } = require("@/core/plugins/acl");

export default {
  name: "HomeService",
  components: { BtnUPAndDown },
  data() {
    return {
      activeNonPersianServices: ["qrLand"],
      down: true,
      dialogSignup: false,
      popupLoading: false,
      loadingPercentageSignup: 100,
      val: "down",
      up: false,
      src: "media/svg/icons/Navigation/Angle-double-down.svg",
      preRegister: ["billboard", "social", "onlineShop"],
      counterBill: 0,
      counterShop: 0,
      counterSoc: 0,
    };
  },
  computed: {
    services() {
      return [
        {
          name: "qrLand",
          gate: "qrLand",
          title: this.$t("services.qrLand.title"),
          description: this.$t("services.qrLand.description"),
          icon: "media/service-logo/qr-land.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.qrLand.property.0") },
            { text: this.$t("services.qrLand.property.1") },
            { text: this.$t("services.qrLand.property.2") },
            { text: this.$t("services.qrLand.property.3") },
          ],
        },
        {
          name: "payamak",
          gate: "payamak",
          title: this.$t("services.payamak.title"),
          description: this.$t("services.payamak.description"),
          icon: "media/service-logo/payamak-land.webp",
          image: "media/bg-service/new-1/payamak-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.payamak.property.0") },
            { text: this.$t("services.payamak.property.1") },
            { text: this.$t("services.payamak.property.2") },
            { text: this.$t("services.payamak.property.3") },
          ],
        },
        {
          name: "robot",
          title: this.$t("services.robot.title"),
          description: this.$t("services.robot.description"),
          gate: "robot",
          icon: "media/service-logo/robot-land.webp",
          image: "media/bg-service/new-1/robot-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.robot.property.0") },
            { text: this.$t("services.robot.property.1") },
            { text: this.$t("services.robot.property.2") },
            { text: this.$t("services.robot.property.3") },
          ],
        },
        {
          name: "infoLand",
          gate: "infoLand",
          title: this.$t("services.infoLand.title"),
          description: this.$t("services.infoLand.description"),
          icon: "media/service-logo/info-land.webp",
          image: "media/bg-service/new-1/info-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.infoLand.property.0") },
            { text: this.$t("services.infoLand.property.1") },
            { text: this.$t("services.infoLand.property.2") },
            { text: this.$t("services.infoLand.property.3") },
          ],
        },
        {
          name: "graphic",
          title: this.$t("services.graphic.title"),
          description: this.$t("services.graphic.description"),
          gate: "graphic",
          icon: "media/service-logo/graphic-land-mix.webp",
          image: "media/bg-service/new-1/graphic-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.graphic.property.0") },
            { text: this.$t("services.graphic.property.1") },
            { text: this.$t("services.graphic.property.2") },
            { text: this.$t("services.graphic.property.3") },
          ],
        },
        {
          name: "bestWebLand",
          gate: "bestWebLand",
          title: this.$t("services.bestWebLand.title"),
          description: this.$t("services.bestWebLand.description"),
          icon: "media/service-logo/web-land-1.webp",
          image: "media/bg-service/new-1/seo-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.bestWebLand.property.0") },
            { text: this.$t("services.bestWebLand.property.1") },
            { text: this.$t("services.bestWebLand.property.2") },
            { text: this.$t("services.bestWebLand.property.3") },
          ],
        },
        {
          name: "onlineShop",
          gate: "onlineShop",
          title: this.$t("services.onlineShop.title"),
          description: this.$t("services.onlineShop.description"),
          icon: "media/service-logo/online-shop-land.webp",
          image: "media/bg-service/new-1/seo-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: this.$t("services.onlineShop.badge"),
          property: [
            { text: this.$t("services.onlineShop.property.0") },
            { text: this.$t("services.onlineShop.property.1") },
            { text: this.$t("services.onlineShop.property.2") },
            { text: this.$t("services.onlineShop.property.3") },
          ],
        },
        {
          name: "social",
          gate: "social",
          title: this.$t("services.social.title"),
          description: this.$t("services.social.description"),
          icon: "media/service-logo/social-media-land.webp",
          image: "media/bg-service/new-1/social-media-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: true,
          badge: false,
          property: [
            { text: this.$t("services.social.property.0") },
            { text: this.$t("services.social.property.1") },
            { text: this.$t("services.social.property.2") },
            { text: this.$t("services.social.property.3") },
          ],
        },
        {
          name: "billboard",
          gate: "billboard",
          title: this.$t("services.billboard.title"),
          description: this.$t("services.billboard.description"),
          icon: "media/service-logo/billboard-land.webp",
          image: "media/bg-service/new-1/billboard-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: true,
          badge: false,
          property: [
            { text: this.$t("services.billboard.property.0") },
            { text: this.$t("services.billboard.property.1") },
            { text: this.$t("services.billboard.property.2") },
            { text: this.$t("services.billboard.property.3") },
          ],
        },
        {
          name: "internationalMedia",
          title: this.$t("services.internationalMedia.title"),
          description: this.$t("services.internationalMedia.description"),
          gate: "internationalMedia",
          icon: "media/service-logo/national-media-land-1.webp",
          image: "media/bg-service/new-1/tv-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.internationalMedia.property.0") },
            { text: this.$t("services.internationalMedia.property.1") },
            { text: this.$t("services.internationalMedia.property.2") },
            { text: this.$t("services.internationalMedia.property.3") },
          ],
        },
        {
          name: "transport",
          gate: "transport",
          title: this.$t("services.transport.title"),
          description: this.$t("services.transport.description"),
          icon: "media/service-logo/terminal-land-1.webp",
          image: "media/bg-service/new-1/ads-metro-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.transport.property.0") },
            { text: this.$t("services.transport.property.1") },
            { text: this.$t("services.transport.property.2") },
            { text: this.$t("services.transport.property.3") },
          ],
        },
        {
          name: "cinema",
          title: this.$t("services.cinema.title"),
          description: this.$t("services.cinema.description"),
          gate: "cinema",
          icon: "media/service-logo/ads-sinema-land-1.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.cinema.property.0") },
            { text: this.$t("services.cinema.property.1") },
            { text: this.$t("services.cinema.property.2") },
            { text: this.$t("services.cinema.property.3") },
          ],
        },
        {
          name: "estate",
          title: this.$t("services.estate.title"),
          description: this.$t("services.estate.description"),
          gate: "estate",
          icon: "media/service-logo/estate-land.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: false,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.estate.property.0") },
            { text: this.$t("services.estate.property.1") },
            { text: this.$t("services.estate.property.2") },
            { text: this.$t("services.estate.property.3") },
          ],
        },
        {
          name: "AIGeneration",
          title: this.$t("services.AIGeneration.title"),
          description: this.$t("services.AIGeneration.description"),
          gate: "AI_generation",
          icon: "media/service-logo/ai-generator.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: false,
          isTest: true,
          isFree: false,
          badge: false,
        },
        {
          name: "ShortLink",
          title: this.$t("services.ShortLink.title"),
          description: this.$t("services.ShortLink.description"),
          gate: "short_link",
          icon: "media/service-logo/short-link.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: false,
          isTest: true,
          isFree: false,
          badge: false,
        },
        {
          name: "QrlandShop",
          title: this.$t("services.QrlandShop.title"),
          description: this.$t("services.QrlandShop.description"),
          gate: "QrlandShop",
          icon: "media/service-logo/QrlandShop.webp",
          image: "media/bg-service/new-1/QrlandShop.webp",
          comingSoon: false,
          isTest: true,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.QrlandShop.property.0") },
            { text: this.$t("services.QrlandShop.property.1") },
            { text: this.$t("services.QrlandShop.property.2") },
            { text: this.$t("services.QrlandShop.property.3") },
          ],
        },
        {
          name: "customer",
          title: this.$t("services.customer.title"),
          description: this.$t("services.customer.description"),
          gate: "customer",
          icon: "media/service-logo/customer-land.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.customer.property.0") },
            { text: this.$t("services.customer.property.1") },
            { text: this.$t("services.customer.property.2") },
            { text: this.$t("services.customer.property.3") },
          ],
        },
        {
          name: "internetBroadcasting",
          title: this.$t("services.internetBroadcasting.title"),
          description: this.$t("services.internetBroadcasting.description"),
          gate: "internetBroadcasting",
          icon: "media/service-logo/ads-internet-land.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.internetBroadcasting.property.0") },
            { text: this.$t("services.internetBroadcasting.property.1") },
            { text: this.$t("services.internetBroadcasting.property.2") },
            { text: this.$t("services.internetBroadcasting.property.3") },
          ],
        },
        {
          name: "emailMarketing",
          title: this.$t("services.emailMarketing.title"),
          description: this.$t("services.emailMarketing.description"),
          gate: "emailMarketing",
          icon: "media/service-logo/marketing-land.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.emailMarketing.property.0") },
            { text: this.$t("services.emailMarketing.property.1") },
            { text: this.$t("services.emailMarketing.property.2") },
            { text: this.$t("services.emailMarketing.property.3") },
          ],
        },
        {
          name: "adsOnStudium",
          title: this.$t("services.adsOnStudium.title"),
          description: this.$t("services.adsOnStudium.description"),
          gate: "adsOnStudium",
          icon: "media/service-logo/studium-land-1.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.adsOnStudium.property.0") },
            { text: this.$t("services.adsOnStudium.property.1") },
            { text: this.$t("services.adsOnStudium.property.2") },
            { text: this.$t("services.adsOnStudium.property.3") },
          ],
        },
        {
          name: "bidOnline",
          title: this.$t("services.bidOnline.title"),
          description: this.$t("services.bidOnline.description"),
          gate: "bidOnline",
          icon: "media/service-logo/bid-online-land-1.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.bidOnline.property.0") },
            { text: this.$t("services.bidOnline.property.1") },
            { text: this.$t("services.bidOnline.property.2") },
            { text: this.$t("services.bidOnline.property.3") },
          ],
        },
        {
          name: "onlineTools",
          title: this.$t("services.onlineTools.title"),
          description: this.$t("services.onlineTools.description"),
          gate: "onlineTools",
          icon: "media/service-logo/tools-land-2.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.onlineTools.property.0") },
            { text: this.$t("services.onlineTools.property.1") },
            { text: this.$t("services.onlineTools.property.2") },
            { text: this.$t("services.onlineTools.property.3") },
          ],
        },
        {
          name: "onlineLearn",
          title: this.$t("services.onlineLearn.title"),
          description: this.$t("services.onlineLearn.description"),
          gate: "onlineLearn",
          icon: "media/service-logo/online-learn-land.webp",
          image: "media/bg-service/new-1/sinama-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.onlineLearn.property.0") },
            { text: this.$t("services.onlineLearn.property.1") },
            { text: this.$t("services.onlineLearn.property.2") },
            { text: this.$t("services.onlineLearn.property.3") },
          ],
        },
        {
          name: "cloud",
          title: this.$t("services.cloud.title"),
          description: this.$t("services.cloud.description"),
          gate: "cloud",
          icon: "media/service-logo/clude-land.webp",
          image: "media/bg-service/new-1/clude-land.webp",
          comingSoon: true,
          isTest: false,
          isFree: false,
          badge: false,
          property: [
            { text: this.$t("services.cloud.property.0") },
            { text: this.$t("services.cloud.property.1") },
            { text: this.$t("services.cloud.property.2") },
            { text: this.$t("services.cloud.property.3") },
          ],
        },
          
      ];
    },
  },
  methods: {
    checkOverflow(index) {
      this.$nextTick(() => {
        let main = document.getElementById(`main.text.${index}`);
        let text = document.getElementById(`text.wrapper.${index}`);

        let mw = main.getBoundingClientRect().width;
        let tw = text.getBoundingClientRect().width;

        if (tw + 10 > mw) {
          text.classList.add("set-transition");
        }
      });

      return "";
    },

    redirectTo(type, gate) {
      if (
        (this.isShow(gate) === "active" && i18n.locale === "fa") ||
        (i18n.locale !== "fa" && this.activeNonPersianServices.includes(gate))
      ) {
        try {
          const url = this[type]();
          return this[type]();
        } catch (e) {
          return "#";
        }
      }
    },
    cinema() {
      let url = this.$showUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    payamak() {
      let url = this.$smsUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    qrLand() {
      let url = this.$qrUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    robot() {
      let url = this.$robotUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    transport() {
      let url = this.$transportUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    billboard() {
      let url = this.$billboardUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    internationalMedia() {
      let url = this.$meliUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    social() {
      let url = this.$mediaUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    infoLand() {
      let url = this.$infoUrl;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    estate() {
      let url = this.$fileUrl; // Fallback URL assumed
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    graphic() {
      let url = this.$graphicUrl; // Fallback URL assumed
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    AIGeneration() {
      let url = this.$aiGenerator;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    ShortLink() {
      let url = this.$shortLink;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    QrlandShop() {
      let url = this.$qrlandshop;
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    motionLand() {
      let url = "https://www.motionland.ir";
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    serviceLand() {
      let url = "https://www.serviceland.ir";
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    seoLand() {
      let url = "http://seoland.ir";
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
    bestWebLand() {
      let url = this.$digiUrl; // Fallback URL assumed
      return `${url}/?token=${localStorage.getItem("id_token")}`;
    },
  },

  // mounted() {
  // if (!localStorage.getItem('bannerWatch')) {
  //   localStorage.setItem('bannerWatch', 1)
  // } else {
  //   localStorage.setItem('bannerWatch', parseInt(localStorage.getItem('bannerWatch')) + 1)
  // }
  //
  // if (parseInt(localStorage.getItem('bannerWatch'))<=10){
  //
  //   this.dialogSignup = true
  //   this.popupLoading = true
  //   if (this.bannerTimerSignup)
  //     return;
  //   this.bannerTimeSignup = 5;
  //
  //   this.bannerTimerSignup = setInterval(() => {
  //     this.bannerTimeSignup -= 1;
  //     if (this.bannerTimeSignup === 0) {
  //       this.popupLoading = false
  //       clearInterval(this.bannerTimerSignup)
  //       this.bannerTimerSignup = null
  //       this.dialogSignup = false
  //     }
  //
  //   }, 10000)
  //
  // }
  // }
};
</script>

<style scoped>
@import "./../../../assets/css/serviceStyle.css";

.main-sec {
  background-color: white;
  border-radius: 25px 0 0 0 !important;
  padding-left: 16px;
  display: flex;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 1;
  width: calc(100% - 104px);
  max-width: calc(100% - 104px);
  overflow: hidden;
}

.main-img-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 70px;
  background-color: white;
  border-radius: 0 50% 50% !important;
  z-index: 3;
  position: relative;
}

.v-badge >>> .v-badge__badge {
  right: 0 !important;
  left: auto !important;
}

.main-text-wrapper {
  padding: 8px 2px 8px 0;
  color: var(--v-primary-base);
  font-size: small;
  font-weight: bold;
  line-height: 1em;
  height: calc(100% - 42px);
  white-space: nowrap;
}

.bottom-sec {
  padding: 8px 12px 8px 8px;
  background-color: var(--v-primary-base);
  height: 42px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 50px 48px 0 50px !important;
  width: calc(100% - 68px);
  color: var(--v-warning-base);
  font-size: smaller;
  display: flex;
  align-items: center;
  z-index: 2;
}

.bottom-sec:before {
  position: absolute;
  content: "";
  width: 40px;
  height: calc(100% - 16px);
  bottom: 0;
  right: 0;
  transform: translateX(calc(100% - 10px));
  background-color: inherit;
}

.bottom-sec:after {
  position: absolute;
  content: "";
  width: 5px;
  height: 9px;
  top: 13px;
  right: 0;
  z-index: 1;
  -webkit-transform: skewY(10deg);
  transform: skewX(20deg);
  background-color: inherit;
}

.bottom-text {
  position: relative;
  z-index: 2;
  line-height: 1em;
}

.set-transition {
  transform: translateX(-100%);
  animation-delay: 1000s;
  animation: scrolling-text 8s infinite linear;
}

@keyframes scrolling-text {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}

[class$="opacity-60"] {
  order: 1;
}

.zoom >>> .v-list-item .v-list-item__title,
.zoom >>> .v-list-item .v-list-item__subtitle {
  word-break: break-word;
  white-space: normal;
}

.zoom :deep(.v-card--link:focus:before) {
  opacity: 0 !important;
}
</style>
<style>
.change-height-down {
  transition: 0.7s !important;
  height: 250px !important;
}

.change-height-up {
  transition: 0.7s !important;
  height: 120px !important;
}

.zoom {
  transition: transform 0.5s;
  /*margin: 0 auto;*/
}

@media screen and (min-width: 960px) {
  .zoom:hover {
    transform: scale(1.1);
  }
}
</style>
